module.exports = __webpack_public_path__ + "img/imgZXGH(18).37461745.png";